import { render, staticRenderFns } from "./LessonResources.vue?vue&type=template&id=8b0d1f9e&scoped=true&"
import script from "./LessonResources.vue?vue&type=script&lang=js&"
export * from "./LessonResources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b0d1f9e",
  null
  
)

export default component.exports